import { useEffect, useMemo, useState } from 'react'
import { api, ErreurApi } from '../api'
import { Horloge } from '../composants/Ecran'
import { useSession } from '../etat/Session'

interface CompteVendeur {
  code: string
  nom: string
  initiales: string
  photo?: string | null
  poste: string
}

/**
 * Un qualificatif tiré au sort à la place du poste, pour égayer l'écran de
 * connexion. Accordé au genre — Yannick est la seule de l'équipe au féminin.
 */
const QUALIFICATIFS: readonly [string, string][] = [
  ['Increvable', 'Increvable'],
  ['Infatigable', 'Infatigable'],
  ['Redoutable au comptoir', 'Redoutable au comptoir'],
  ['Implacable', 'Implacable'],
  ['Toujours partant', 'Toujours partante'],
  ['Une force tranquille', 'Une force tranquille'],
  ['Champion du rayon', 'Championne du rayon'],
  ['Négociateur hors pair', 'Négociatrice hors pair'],
  ['Increvable au sourire', 'Increvable au sourire'],
  ['Meilleur ami des vieux meubles', 'Meilleure amie des vieux meubles'],
  ['Dénicheur de pépites', 'Dénicheuse de pépites'],
  ['Roi du dépôt', 'Reine du dépôt'],
  ['Toujours de bonne humeur', 'Toujours de bonne humeur'],
  ['Increvable un jour de solde', 'Increvable un jour de solde'],
  ['Pilier du magasin', 'Pilier du magasin'],
  ['Œil de lynx sur les étiquettes', 'Œil de lynx sur les étiquettes'],
  ['Increvable, même le samedi', 'Increvable, même le samedi'],
  ['Rapide comme l’éclair', 'Rapide comme l’éclair'],
  ['Fin limier des bonnes affaires', 'Fine limière des bonnes affaires'],
  ['As de la caisse', 'As de la caisse'],
  ['Maestro de l’étiquette', 'Maestra de l’étiquette'],
  ['Doué pour marchander', 'Douée pour marchander'],
  ['Toujours souriant', 'Toujours souriante'],
  ['Increvable dès l’ouverture', 'Increvable dès l’ouverture'],
  ['Patient comme personne', 'Patiente comme personne'],
  ['Gardien du rayon', 'Gardienne du rayon'],
  ['Sherlock du bric-à-brac', 'Sherlock du bric-à-brac'],
  ['Increvable même sans café', 'Increvable même sans café'],
  ['Précis au centime près', 'Précise au centime près'],
  ['Vétéran du comptoir', 'Vétérane du comptoir'],
  ['Toujours prêt à dépanner', 'Toujours prête à dépanner'],
  ['Increvable un jour de foule', 'Increvable un jour de foule'],
  ['Œil affûté, geste sûr', 'Œil affûté, geste sûr'],
  ['Increvable de bonne humeur', 'Increvable de bonne humeur'],
  ['Bâtisseur de fidélité client', 'Bâtisseuse de fidélité client'],
  ['Increvable jusqu’à la fermeture', 'Increvable jusqu’à la fermeture'],
  ['Meilleur compteur de caisse', 'Meilleure compteuse de caisse'],
  ['Aussi rapide que discret', 'Aussi rapide que discrète'],
  ['Increvable, en toute saison', 'Increvable, en toute saison'],
  ['Toujours au bon prix', 'Toujours au bon prix'],
  ['Champion de la démarque', 'Championne de la démarque'],
  ['Increvable, jour après jour', 'Increvable, jour après jour'],
  ['Aussi habile que patient', 'Aussi habile que patiente'],
  ['Increvable au dépôt du lundi', 'Increvable au dépôt du lundi'],
  ['Toujours de bon conseil', 'Toujours de bon conseil'],
  ['Increvable, comme au premier jour', 'Increvable, comme au premier jour'],
  ['Grand connaisseur d’antiquités', 'Grande connaisseuse d’antiquités'],
  ['Increvable même un lundi', 'Increvable même un lundi'],
  ['Toujours partant pour un inventaire', 'Toujours partante pour un inventaire'],
  ['Increvable devant la file d’attente', 'Increvable devant la file d’attente'],
  ['Négociateur né', 'Négociatrice née'],
  ['Increvable, même sous la pluie', 'Increvable, même sous la pluie'],
  ['Encyclopédie du bon prix', 'Encyclopédie du bon prix'],
  ['Increvable un jour de solde XXL', 'Increvable un jour de solde XXL'],
  ['Toujours calme, même au rush', 'Toujours calme, même au rush'],
  ['Increvable, sans exception', 'Increvable, sans exception'],
  ['Maître du rangement', 'Maîtresse du rangement'],
  ['Increvable de A à Z', 'Increvable de A à Z'],
  ['Debout dès potron-minet', 'Debout dès potron-minet'],
  ['Increvable même à jeun', 'Increvable même à jeun'],
  ['Chasseur de fausses pièces', 'Chasseuse de fausses pièces'],
  ['Toujours le mot pour rire', 'Toujours le mot pour rire'],
  ['Increvable, du matin au soir', 'Increvable, du matin au soir'],
  ['Grand spécialiste du bazar', 'Grande spécialiste du bazar'],
  ['Increvable, câlin compris', 'Increvable, câlin compris'],
  ['Roi de la remise', 'Reine de la remise'],
  ['Increvable, sourire garanti', 'Increvable, sourire garanti'],
  ['Fidèle au poste', 'Fidèle au poste'],
  ['Increvable un jour de canicule', 'Increvable un jour de canicule'],
  ['Amoureux des vieilles pendules', 'Amoureuse des vieilles pendules'],
  ['Increvable, même en pleine tempête', 'Increvable, même en pleine tempête'],
  ['As de la négociation éclair', 'As de la négociation éclair'],
  ['Increvable, quoi qu’il arrive', 'Increvable, quoi qu’il arrive'],
  ['Grand organisateur de rayon', 'Grande organisatrice de rayon'],
  ['Increvable, café ou pas', 'Increvable, café ou pas'],
  ['Toujours le geste juste', 'Toujours le geste juste'],
  ['Increvable, pause déjeuner comprise', 'Increvable, pause déjeuner comprise'],
  ['Détective des petits prix', 'Détective des petits prix'],
  ['Increvable, à toute heure', 'Increvable, à toute heure'],
  ['Plus rapide que la douchette', 'Plus rapide que la douchette'],
  ['Increvable, tout sourire', 'Increvable, tout sourire'],
  ['Fin connaisseur de brocante', 'Fine connaisseuse de brocante'],
  ['Increvable, saison après saison', 'Increvable, saison après saison'],
  ['Toujours prêt à négocier', 'Toujours prête à négocier'],
  ['Increvable, même après l’inventaire', 'Increvable, même après l’inventaire'],
  ['Champion du recollage d’étiquettes', 'Championne du recollage d’étiquettes'],
  ['Increvable, ticket après ticket', 'Increvable, ticket après ticket'],
  ['Grand maître du rangement', 'Grande maîtresse du rangement'],
  ['Increvable, comme un lundi matin', 'Increvable, comme un lundi matin'],
  ['Toujours partant pour un coup de main', 'Toujours partante pour un coup de main'],
  ['Increvable, réserve comprise', 'Increvable, réserve comprise'],
  ['Vaillant soldat du comptoir', 'Vaillante soldate du comptoir'],
  ['Increvable, à la caisse comme au rayon', 'Increvable, à la caisse comme au rayon'],
  ['Toujours le bon mot', 'Toujours le bon mot'],
  ['Increvable, même sans pause', 'Increvable, même sans pause'],
  ['Expert en vieux disques', 'Experte en vieux disques'],
  ['Increvable, un jour de grand nettoyage', 'Increvable, un jour de grand nettoyage'],
  ['Rapide comme une caisse enregistreuse', 'Rapide comme une caisse enregistreuse'],
  ['Increvable, semaine après semaine', 'Increvable, semaine après semaine'],
  ['Toujours au taquet', 'Toujours au taquet'],
  ['Increvable, avant même le café', 'Increvable, avant même le café'],
]

const PRENOMS_FEMININS = new Set(['yannick'])

/**
 * Un qualificatif par personne, jamais le même deux fois dans la même liste :
 * on mélange les index une fois, puis on les distribue dans l'ordre. Avec
 * cinq comptes et une centaine de qualificatifs, un tirage indépendant par
 * personne les ferait parfois coïncider — pas ici.
 */
function qualificatifsSansRepetition(noms: string[]): string[] {
  const index = QUALIFICATIFS.map((_, i) => i)
  for (let i = index.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[index[i], index[j]] = [index[j]!, index[i]!]
  }
  return noms.map((nom, i) => {
    const [m, f] = QUALIFICATIFS[index[i % index.length]!]!
    return PRENOMS_FEMININS.has(nom.trim().toLowerCase()) ? f : m
  })
}

/**
 * Connexion au poste : on choisit son visage dans la liste, on tape 4 chiffres.
 * Pas de clavier à l'écran ni de champ mot de passe — le comptoir n'a pas le
 * temps, et le PIN ne sert qu'à attribuer les ventes au bon vendeur.
 */
export function Connexion() {
  const { connecter } = useSession()
  const [comptes, setComptes] = useState<CompteVendeur[]>([])
  const [code, setCode] = useState<string>('')
  const [pin, setPin] = useState('')
  const [erreur, setErreur] = useState<string | null>(null)
  const [envoi, setEnvoi] = useState(false)
  const [essai, setEssai] = useState(0)
  const [recherche, setRecherche] = useState(true)

  // Tiré une fois par ouverture de l'écran, pas à chaque rendu — sinon le
  // qualificatif changerait sous les yeux au moindre clic.
  const qualificatifs = useMemo(() => {
    const nommes = comptes.filter((c) => c.nom.trim().toLowerCase() !== 'invité')
    const tires = qualificatifsSansRepetition(nommes.map((c) => c.nom))
    return Object.fromEntries(nommes.map((c, i) => [c.code, tires[i]]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comptes.length])

  /**
   * Chargement des comptes — et le seul endroit où l'on sait dire pourquoi
   * rien ne s'affiche.
   *
   * La coquille de l'application est en cache : elle s'ouvre même sans réseau,
   * et l'écran de connexion apparaît alors parfaitement normal, mais vide.
   * L'utilisateur voit une liste sans nom et n'a aucun moyen de comprendre.
   * On distingue donc les deux causes — l'appareil est hors ligne, ou le
   * serveur ne répond pas — et on réessaie tout seul.
   */
  useEffect(() => {
    let vivant = true
    setRecherche(true)
    api<{ vendeurs: CompteVendeur[] }>('/vendeurs')
      .then((r) => {
        if (!vivant) return
        setComptes(r.vendeurs)
        setErreur(null)
        if (r.vendeurs.length === 1) setCode(r.vendeurs[0]!.code)
      })
      .catch((cause: unknown) => {
        if (!vivant) return
        setErreur(
          !navigator.onLine
            ? 'Cet iPad n’est pas connecté au réseau.'
            : cause instanceof ErreurApi && cause.statut === 0
              ? 'Serveur injoignable. Vérifiez que Tailscale est connecté sur cet appareil — l’icône VPN doit apparaître en haut de l’écran.'
              : cause instanceof ErreurApi
                ? cause.message
                : 'Serveur injoignable.',
        )
      })
      .finally(() => vivant && setRecherche(false))
    return () => {
      vivant = false
    }
  }, [essai])

  // Nouvelle tentative toutes les dix secondes tant qu'aucun compte n'est
  // arrivé : le réseau revient souvent tout seul, et personne ne devrait avoir
  // à recharger une caisse à la main.
  useEffect(() => {
    if (comptes.length > 0) return
    const minuterie = window.setInterval(() => setEssai((n) => n + 1), 10_000)
    return () => window.clearInterval(minuterie)
  }, [comptes.length])

  // Dès que le PIN est complet, on tente la connexion : pas de bouton à viser.
  useEffect(() => {
    if (pin.length !== 4 || !code || envoi) return
    setEnvoi(true)
    setErreur(null)
    connecter(code, pin)
      .catch((cause: unknown) => {
        setErreur(cause instanceof ErreurApi ? cause.message : 'Connexion impossible.')
        setPin('')
      })
      .finally(() => setEnvoi(false))
  }, [pin, code, connecter, envoi])

  const taper = (chiffre: string) => {
    if (!code) {
      setErreur('Choisissez d’abord votre nom.')
      return
    }
    setPin((actuel) => (actuel + chiffre).slice(0, 4))
  }

  const choisi = comptes.find((c) => c.code === code) ?? null

  // Clavier physique de l'ordinateur : mêmes chiffres qu'au pavé tactile,
  // Backspace pour effacer un chiffre, Échap pour tout vider.
  useEffect(() => {
    if (!choisi) return
    const surTouche = (e: KeyboardEvent) => {
      if (/^[0-9]$/.test(e.key)) {
        taper(e.key)
      } else if (e.key === 'Backspace') {
        setPin((p) => p.slice(0, -1))
      } else if (e.key === 'Escape') {
        setPin('')
        setErreur(null)
      }
    }
    window.addEventListener('keydown', surTouche)
    return () => window.removeEventListener('keydown', surTouche)
  }, [choisi])

  return (
    <div className="connexion">
      <div className="connexion-horloge">
        <Horloge />
      </div>
      <div className={choisi ? 'connexion-boite' : 'connexion-boite large'}>
        <div>
          <div className="etiquette">Troc en Stock · Dépôt-vente</div>
          <h3 style={{ margin: '4px 0 0' }}>
            {choisi ? 'Ouverture de caisse' : 'Qui ouvre la caisse ?'}
          </h3>
        </div>

        {/* Tant que personne n'est choisi, les visages occupent tout l'écran :
            on vise une photo, pas une ligne de liste. */}
        {!choisi && (
          <div className="profils">
            {comptes.map((compte) => (
              <button
                key={compte.code}
                type="button"
                className="profil"
                onClick={() => {
                  setCode(compte.code)
                  setPin('')
                  setErreur(null)
                }}
              >
                <span className="profil-vignette">
                  {compte.photo ? (
                    <img src={compte.photo} alt="" />
                  ) : (
                    <span className="profil-initiales">{compte.initiales}</span>
                  )}
                </span>
                <span className="profil-nom">{compte.nom}</span>
                <span className="profil-poste">{qualificatifs[compte.code] ?? compte.poste}</span>
              </button>
            ))}
          </div>
        )}

        {comptes.length === 0 && !erreur && <div className="vide">Chargement des comptes…</div>}
        {comptes.length === 0 && erreur && (
          <button
            type="button"
            className="btn btn-secondaire btn-bloc btn-centre"
            disabled={recherche}
            onClick={() => setEssai((n) => n + 1)}
          >
            {recherche ? 'Nouvelle tentative…' : 'Réessayer'}
          </button>
        )}

        {/* Une fois le visage choisi, il reste affiché en grand : on doit voir
            sous quel nom on s'apprête à encaisser. */}
        {choisi && (
          <>
            <button
              type="button"
              className="profil-choisi"
              onClick={() => {
                setCode('')
                setPin('')
                setErreur(null)
              }}
              title="Choisir quelqu’un d’autre"
            >
              <span className="profil-vignette">
                {choisi.photo ? (
                  <img src={choisi.photo} alt="" />
                ) : (
                  <span className="profil-initiales">{choisi.initiales}</span>
                )}
              </span>
              <span>
                <span className="profil-nom">{choisi.nom}</span>
                <span className="profil-changer">Ce n’est pas vous ?</span>
              </span>
            </button>

            <div>
              <div className="etiquette" style={{ marginBottom: 8 }}>
                Code personnel à 4 chiffres
              </div>
              <div className="pin-points" aria-label={`${pin.length} chiffres saisis sur 4`}>
                {[0, 1, 2, 3].map((i) => (
                  <span key={i} className={i < pin.length ? 'pin-point plein' : 'pin-point'} />
                ))}
              </div>
            </div>

            <div className="pave">
              {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((touche) => (
                <button
                  key={touche}
                  type="button"
                  className="pave-touche"
                  onClick={() => taper(touche)}
                >
                  {touche}
                </button>
              ))}
              <button
                type="button"
                className="pave-touche secondaire"
                onClick={() => {
                  setPin('')
                  setErreur(null)
                }}
              >
                C
              </button>
              <button type="button" className="pave-touche" onClick={() => taper('0')}>
                0
              </button>
              <button
                type="button"
                className="pave-touche secondaire"
                onClick={() => setPin((p) => p.slice(0, -1))}
              >
                ←
              </button>
            </div>
          </>
        )}

        {erreur && (
          <div className="note" style={{ borderColor: 'var(--color-accent-800)' }}>
            {erreur}
          </div>
        )}
      </div>
    </div>
  )
}
